import { Option } from "@models/common";
import { Trans } from "react-i18next";
import { CommonButton } from "@components/CommonButton";
import { Badge } from "antd";
import { themeActionAtom } from "@src/jotai/theme";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export interface TabOption extends Option {
  badge?: number;
  dot?: boolean;
}

interface TabsProps {
  type?: "btn" | "text";
  value: string;
  options: TabOption[];
  onChange: (value: string) => void;
}
export const Tabs = ({ value, options, type = "btn", onChange }: TabsProps) => {
  const isDark = useAtomValue(themeActionAtom) === "dark";
  const isLight = !isDark;
  return (
    <div className="flex flex-row items-center gap-[16px]">
      {options.map((option) => {
        const hasBadge = (option as TabOption).badge != null && (option as TabOption).badge! > 0;
        const hasDot = !!(option as TabOption).dot;
        let btn: any;
        if (type === "btn") {
          const isSelected = option.value === value;
          btn = (
            <CommonButton
              type={isSelected ? (isDark ? "default" : "primary") : "text"}
              onClick={() => onChange(option.value)}
              className={twMerge(
                "border-transparent! relative rounded-[4px]!",
                !isSelected && "text-kds-fg-subtle!",
                isLight && isSelected ? "bg-kds-bg-subtle! text-kds-fg! border! border-kds-border! shadow-none!" : "",
              )}
              key={option.value}
            >
              <Trans>{option.label}</Trans>
            </CommonButton>
          );
          if (hasBadge) {
            btn = (
              <Badge count={(option as TabOption).badge} size="small" offset={[-2, 2]} className="text-kds-fg!">
                {btn}
              </Badge>
            );
          }
        } else if (type === "text") {
          btn = (
            <CommonButton
              type="text"
              onClick={() => onChange(option.value)}
              className={twMerge(
                "border-none! relative",
                option.value === value ? "text-kds-fg! font-bold!" : "text-kds-fg-subtle!",
              )}
              key={option.value}
            >
              <Trans>{option.label}</Trans>
              {hasDot && <div className="w-[8px] h-[8px] bg-kds-danger rounded-full"></div>}
            </CommonButton>
          );
        }
        return (
          <div key={option.value} className="relative inline-flex tabs-item">
            {btn}
          </div>
        );
      })}
    </div>
  );
};
